import ProductService from '@/api/products/productsService.js';
/* eslint-disable */

// I5618: only the two list calls drive the spinner, and only the newest ends it: the late answer
// for a tab just left neither reveals the new tab's empty table nor holds up its loaded list.
const startListLoading = (state) => {
  state.listCall = (state.listCall || 0) + 1;
  state.loading = true;
  return state.listCall;
};
const stopListLoading = (state, call) => {
  if (call === state.listCall) state.loading = false;
};

export const dashboard = {
  namespaced: true,
  state: () => ({
    loading: false,
    listCall: 0,
    incompleteOrdersList: [],
    completeOrdersList: [],
    transactionId: null,
    showConfirmation: false,
    logisticsConfirmation: false,

    orderNotifications: [],
    retailers: null,
    markets: null,
    // Add submissionFailedList to state
    submissionFailedList: [],
    // I4833 TD-4: reactive loading-state in Vuex (per-transactionId).
    // tableData reads this to render spinners; mutating row objects directly
    // is overwritten on every computed recompute.
    loadingTxIds: [],
    // I4833 TD-12 (optimistic UI follow-up): txIds whose submit succeeded
    // server-side but for which the refetch hasn't yet removed them from
    // incompleteOrdersList. tableData treats these as 'done' so the row
    // doesn't flash back to a "Submit" button between per-row finalize and
    // the final collective refetch (~12s window for a 50-product bulk).
    // Cleared in setIncompleteOrdersList finally — refetched data is the
    // source of truth from that point on.
    pendingSubmittedTxIds: [],
  }),

  getters: {
    getOrderNotifications(state) {
      return state.orderNotifications;
    },
    getIncompleteOrdersList(state) {
      return state.incompleteOrdersList;
    },

    getCompletedOrdersList(state) {
      return state.completeOrdersList;
    },

    getIncompleteOrder: (state) => (id) => {
      const order = state.incompleteOrdersList.find((e) => e.transactionId == id);
      return order;
    },

    getCompleteOrder: (state) => (id) => {
      const order = state.completeOrdersList.find((e) => e.transactionId == id);
      return order;
    },

    getIncompleteOrders: (state, getters ,rootState, rootGetters ) => () => {
      const orders = state.incompleteOrdersList.filter((e) => rootGetters['order/getListOfRegisteredProducts'].includes(e.transactionId));
      return orders;
    },

    getRetailers(state) {
      return state.retailers;
    },

    getMarkets(state) {
      return state.markets;
    },

    getLogisticsInformation: (state) => (transactionId, versionInd, unitType) => {
      let order = state.incompleteOrdersList.find((e) => e.transactionId == transactionId);

      if (!order) {
        order = state.completeOrdersList.find((e) => e.transactionId == transactionId);
      }

      const logisticsInformation = JSON.parse(JSON.stringify(order.logisticsInformation));
      if (logisticsInformation) {
        const serverData = logisticsInformation[versionInd].variantLine.find(
          (variant) => variant.tradeItem.tradeItemUnitDescriptorCode == unitType
        );
        if (serverData) {
          return serverData.data;
        }
      }

      return {};
    },

    getPrevOrder: (state) => (transactionId) => {
      const currentTransactionIndex = state.incompleteOrdersList.findIndex((e) => e.transactionId == transactionId);
      const prevInd =
        currentTransactionIndex == 0 ? state.incompleteOrdersList.length - 1 : currentTransactionIndex - 1;
      return state.incompleteOrdersList[prevInd].transactionId;
    },

    getNextOrder: (state) => (transactionId) => {
      const currentTransactionIndex = state.incompleteOrdersList.findIndex((e) => e.transactionId == transactionId);
      const nextInd =
        currentTransactionIndex == state.incompleteOrdersList.length - 1 ? 0 : currentTransactionIndex + 1;
      return state.incompleteOrdersList[nextInd].transactionId;
    },

    getShowConfirmation(state) {
      return state.showConfirmation;
    },

    getLogisticsConfirmation(state) {
      return state.logisticsConfirmation;
    },

    getSubmissionFailedList(state) {
      return state.submissionFailedList;
    },
    // I4833 TD-4 — shallow copy so consumers can't bypass mutations by .push'ing
    // into the returned reference. Cheap; loadingTxIds is bounded by selected.length.
    getLoadingTxIds(state) {
      return [...state.loadingTxIds];
    },
    // I4833 TD-12 — optimistic 'done' override for rows whose finalize has
    // returned 200 but whose absence from incompleteOrdersList awaits the
    // collective refetch. Shallow copy for the same reason as above.
    getPendingSubmittedTxIds(state) {
      return [...state.pendingSubmittedTxIds];
    },
  },

  mutations: {
    SET_ORDERS_LIST(state, payload) {
      console.log('SET_ORDERS_LIST', payload)
      state.incompleteOrdersList = JSON.parse(JSON.stringify(payload));
    },
    SET_COMPLETED_ORDERS_LIST(state, payload) {
      console.log('SET_COMPLETED_ORDERS_LIST', payload)
      state.completeOrdersList = JSON.parse(JSON.stringify(payload));
    },

    SET_SHOW_CONFIRMATION(state, payload) {
      state.showConfirmation = payload;
    },

    SET_LOGISTICS_CONFIRMATION(state, payload) {
      state.logisticsConfirmation = payload;
    },

    SET_TRANSACTION_ID(state, payload) {
      state.transactionId = payload;
    },

    ADD_ORDER_NOTIFICATION(state, payload) {
      state.orderNotifications.push(payload);
    },
    REMOVE_ORDER_NOTIFICATION(state, payload) {
      state.orderNotifications = state.orderNotifications.filter((e) => e != payload);
    },
    SET_ORDER_NOTIFICATIONS(state, payload) {
      state.orderNotifications = payload;
    },
    SET_RETAILERS(state, payload) {
      if (!payload) {
        return;
      }
      state.retailers = JSON.parse(JSON.stringify(payload));
    },
    SET_MARKETS(state, payload) {
      if (!payload) {
        return;
      }
      state.markets = JSON.parse(JSON.stringify(payload));
    },
    SET_SUBMISSION_FAILED_LIST(state, list) {
      state.submissionFailedList = list;
    },
    ADD_TO_SUBMISSION_FAILED_LIST(state, transactionId) {
      if (!state.submissionFailedList.includes(transactionId)) {
        state.submissionFailedList.push(transactionId);
      }
    },
    REMOVE_FROM_SUBMISSION_FAILED_LIST(state, transactionId) {
      state.submissionFailedList = state.submissionFailedList.filter(id => id !== transactionId);
    },
    CLEAR_SUBMISSION_FAILED_LIST(state) {
      state.submissionFailedList = [];
    },
    // I4833 TD-4: loadingTxIds mutations.
    ADD_TO_LOADING_LIST(state, transactionId) {
      if (!state.loadingTxIds.includes(transactionId)) {
        state.loadingTxIds.push(transactionId);
      }
    },
    REMOVE_FROM_LOADING_LIST(state, transactionId) {
      state.loadingTxIds = state.loadingTxIds.filter(id => id !== transactionId);
    },
    CLEAR_LOADING_LIST(state) {
      state.loadingTxIds = [];
    },
    // I4833 TD-12: optimistic-success markers cleared by refetch finally.
    ADD_TO_PENDING_SUBMITTED(state, transactionId) {
      if (!state.pendingSubmittedTxIds.includes(transactionId)) {
        state.pendingSubmittedTxIds.push(transactionId);
      }
    },
    CLEAR_PENDING_SUBMITTED(state) {
      state.pendingSubmittedTxIds = [];
    },
  },

  actions: {
    removeOrderNotification({ commit }, payload) {
      commit('REMOVE_ORDER_NOTIFICATION', payload);
    },
    addOrderNotification({ commit }, payload) {
      commit('ADD_ORDER_NOTIFICATION', payload);
    },
    setOrderNotifications({ commit }, payload) {
      commit('SET_ORDER_NOTIFICATIONS', payload);
    },

    async getRetailers({ commit }) {
      try {
        const res = await ProductService.getRetailers();
        commit('SET_RETAILERS', res.data);
      } catch (error) {
        console.log('GET RETAILER', error);
      }
    },

    async getMarkets({ commit }) {
      try {
        const res = await ProductService.getMarkets();
        commit('SET_MARKETS', res.data);
      } catch (error) {
        console.log('GET MARKETS', error);
      }
    },

    // I4833 TD-11: returns { success, error } — no re-throw so existing
    //   mounted-hook callers keep working.
    // I4833 TD-10: CLEAR_LOADING_LIST in finally (not at start) so spinners
    //   remain visible during the refetch roundtrip, then clear in one place.
    async setIncompleteOrdersList({ commit, state }) {
      const call = startListLoading(state);
      try {
        const res = await ProductService.getIncompleteRegistration();
        commit('SET_ORDERS_LIST', [...res]);
        return { success: true };
      } catch (error) {
        console.log('GET INCOMPLETE', error);
        return { success: false, error };
      } finally {
        commit('CLEAR_LOADING_LIST');
        // TD-12: refetched list is the new source of truth — submitted items
        // either gone from the list (success) or still present (refetch faal,
        // user will be told to refresh manually); clear the optimistic state
        // either way so we don't carry stale 'done' overrides forever.
        commit('CLEAR_PENDING_SUBMITTED');
        stopListLoading(state, call);
      }
    },
    async setCompletedOrderList({ commit, state }, list) {
      const call = startListLoading(state);
      try {
        const res = await ProductService.getHistory();
        commit('SET_COMPLETED_ORDERS_LIST', [...res]);
      } catch (error) {
        console.log('GET COMPLETED', error);
      } finally {
        stopListLoading(state, call);
      }
    },


    setOrderId({ commit, state }, id) {
      commit('SET_TRANSACTION_ID', id);
    },

    setShowConfirmation({ commit }, status) {
      commit('SET_SHOW_CONFIRMATION', status);
    },

    setLogisticsConfirmation({ commit }, status) {
      commit('SET_LOGISTICS_CONFIRMATION', status);
    }
  }
};
